import { useSyncExternalStore } from 'react';

let height = 0;
let bounds: { top: number; height: number | (() => number) } | undefined;
const listeners = new Set<() => void>();

/** Records desktop search bounds even before the controls become fixed. */
export const setStickySearchControlsBounds = (nextBounds: typeof bounds) => {
  bounds = nextBounds;
};

/** Predicts the search offset at the destination of an anchor scroll. */
export const getStickySearchControlsHeightAt = (scrollY: number) => {
  if (!bounds || scrollY < bounds.top) return 0;
  return typeof bounds.height === 'function' ? bounds.height() : bounds.height;
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Shares the occupied viewport height across separately mounted page components. */
export const setStickySearchControlsHeight = (nextHeight: number) => {
  if (height === nextHeight) return;
  height = nextHeight;
  listeners.forEach((listener) => listener());
};

const useStickySearchControlsHeight = () =>
  useSyncExternalStore(
    subscribe,
    () => height,
    () => 0,
  );

export default useStickySearchControlsHeight;
